import { BedOutlineIcon } from './BedOutlineIcon';

/**
 * author: Google
 * id 860292B0-C722-4829-9E30-AACF00D09C8C
 * name bed-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/bed-outline.svg
 * tags
 * - Home Automation 
 * - Holiday 
 */
export const HotelOutlineIcon = BedOutlineIcon;
export default HotelOutlineIcon